import { IAction } from '@shared-components/models';
import { GET_DEAL_DETAILS_SUCCESS } from './deal.constant';

export const getDealDetailsSuccess = (payload: any): IAction => ({
  type: GET_DEAL_DETAILS_SUCCESS,
  payload,
});

